export const SubnetForms = {
  Fabric: "Fabric",
  VLAN: "VLAN",
  Space: "Space",
  Subnet: "Subnet",
} as const;

export const SubnetsUrlParams = {
  By: "by",
  Q: "q",
};
